export const GET_HARDNESS_TEST_REQUEST = "GET_HARDNESS_TEST_REQUEST";
export const GET_HARDNESS_TEST_SUCCESS = "GET_HARDNESS_TEST_SUCCESS";
export const GET_HARDNESS_TEST_FAILURE = "GET_HARDNESS_TEST_FAILURE";

export const DELETE_HARDNESS_TEST_REQUEST = "DELETE_HARDNESS_TEST_REQUEST";
export const DELETE_HARDNESS_TEST_SUCCESS = "DELETE_HARDNESS_TEST_SUCCESS";
export const DELETE_HARDNESS_TEST_FAILURE = "DELETE_HARDNESS_TEST_FAILURE";

export const CREATE_HARDNESS_TEST_REQUEST = "CREATE_HARDNESS_TEST_REQUEST";
export const CREATE_HARDNESS_TEST_SUCCESS = "CREATE_HARDNESS_TEST_SUCCESS";
export const CREATE_HARDNESS_TEST_FAILURE = "CREATE_HARDNESS_TEST_FAILURE";

export const EDIT_HARDNESS_TEST_REQUEST = "EDIT_HARDNESS_TEST_REQUEST";
export const EDIT_HARDNESS_TEST_SUCCESS = "EDIT_HARDNESS_TEST_SUCCESS";
export const EDIT_HARDNESS_TEST_FAILURE = "EDIT_HARDNESS_TEST_FAILURE";


export const UPLOADCSV_HARDNESS_TEST_REQUEST = "UPLOADCSV_HARDNESS_TEST_REQUEST";
export const UPLOADCSV_HARDNESS_TEST_SUCCESS = "UPLOADCSV_HARDNESS_TEST_SUCCESS";
export const UPLOADCSV_HARDNESS_TEST_FAILURE = "UPLOADCSV_HARDNESS_TEST_FAILURE";


export const UPLOADCSV_TENSILE_TEST_REQUEST = "UPLOADCSV_TENSILE_TEST_REQUEST";
export const UPLOADCSV_TENSILE_TEST_SUCCESS = "UPLOADCSV_TENSILE_TEST_SUCCESS";
export const UPLOADCSV_TENSILE_TEST_FAILURE = "UPLOADCSV_TENSILE_TEST_FAILURE";